const messages = {
  title: 'Pristup odbijen',
  description: 'Nemate pristup ovom resursu',
  backHomeButton: 'Nazad na kontrolnu tablu'
}

export default {
  messages
}
